import React, { CSSProperties } from "react";
import { Subscription } from "rxjs";
import NavigationTokens from "../../constants/navigationTokens";
import { IDisplayState } from "../../interfaces/IDisplayState";
import NavigationTokensService from "../../utilities/navigationTokensService";
import UserService from "../../utilities/userService";
import Icon from "../icon/icon";
import DesktopDropdown from "../navMenu/desktopDropdown";
import NotificationCount from "../notifications/notificationCount";
import UserGreeting from "../userGreeting/userGreeting";
import "./userPanel.scss";
import MenuItemService from "../../utilities/menuItemService";
import LoginUrlService from "../../utilities/loginUrlService";
import MyListsHeaderClient from "../myLists/myListsHeaderClient";
import ConfigProps from "../../constants/configProps";
import ConfigPropService from "../../utilities/configPropService";
import { WBMUrlService } from "@wbmason/url-service";
import { BaseHostUrlService } from "../../utilities/baseHostUrlService";
import EnvironmentService from "../../utilities/environmentService";

export interface IUserPanelProps {
  style?: CSSProperties;
  isLoggedIn: boolean;
  isCookied: boolean;
  firstName: string;
  displayState: IDisplayState;
  useNotificationAnimation: boolean;
  setNotificationsOpen: (value: boolean) => void;
  notificationCount: number;
  hasMultipleAccounts: boolean;
  styleDropdown?: CSSProperties;
  myListsUrl?: string;
  setMyListsOpen: (value: boolean) => void;
}

export interface IUserPanelState {
  ordersHref: string;
  dashboardHref: string;
  loginHref: string;
  registerHref: string;
  setMyAccountAndPaymentsHasMouse: boolean;
  myAccountAndPaymentsMenuHasMouse: boolean;
  myAccountAndPaymentsHasMouse: boolean;
  onlineInvoicingSignUpUrl: boolean;
  oiSignup: string;
  accountStatement: string;
}

class UserPanel extends React.Component<IUserPanelProps, IUserPanelState> {
  constructor(props: IUserPanelProps) {
    super(props);

    this.state = {
      ordersHref: "",
      dashboardHref: "",
      loginHref: "",
      registerHref: "",
      setMyAccountAndPaymentsHasMouse: false,
      myAccountAndPaymentsMenuHasMouse: false,
      myAccountAndPaymentsHasMouse: false,
      onlineInvoicingSignUpUrl: false,
      oiSignup: "",
      accountStatement: "",
    };

    this.setMyAccountAndPaymentsHasMouse =
      this.setMyAccountAndPaymentsHasMouse.bind(this);
    this.setMyAccountAndPaymentsMenuHasMouse =
      this.setMyAccountAndPaymentsMenuHasMouse.bind(this);
    this.closeAccountAndPaymentDropdown =
      this.closeAccountAndPaymentDropdown.bind(this);
  }

  private navTokenSub: Subscription | undefined;
  private onlineInvoicingSignUpUrl: Subscription | undefined;
  private loginUrlSub: Subscription | undefined;
  private configPropSub: Subscription | undefined;

  componentDidMount() {
    if (typeof document !== undefined) {
      document.addEventListener(
        "closeAccountAndPaymentDropdown",
        this.closeAccountAndPaymentDropdown,
      );
    }

    this.navTokenSub = NavigationTokensService.get([
      NavigationTokens.orderHistory,
      NavigationTokens.regUserRegistration,
      NavigationTokens.OISignup,
      NavigationTokens.accountStatement,
    ]).subscribe((response) => {
      this.setState({
        ordersHref: response[NavigationTokens.orderHistory],
        registerHref: response[NavigationTokens.regUserRegistration],
        oiSignup: response[NavigationTokens.OISignup],
        accountStatement: response[NavigationTokens.accountStatement],
      });
    });

    this.configPropSub = ConfigPropService.get([
      ConfigProps.EnableResponsiveAccountDashboard,
    ]).subscribe((configProps: Record<string, string>) => {
      const enableResponsiveAccountDashboard = ConfigPropService.isYesOrTrue(
        configProps[ConfigProps.EnableResponsiveAccountDashboard],
      );

      const accountDashboardUrl = WBMUrlService.getAccountDashboardUrl(
        BaseHostUrlService.get(),
        `${
          enableResponsiveAccountDashboard
            ? EnvironmentService.get().ecomVnextUrl
            : EnvironmentService.get().ecom
        }`,
        enableResponsiveAccountDashboard,
      );

      this.setState({
        dashboardHref: accountDashboardUrl,
      });
    });

    this.onlineInvoicingSignUpUrl =
      MenuItemService.onlineInvoicingSignUpUrl().subscribe((value) => {
        this.setState({
          onlineInvoicingSignUpUrl: value,
        });
      });

    this.loginUrlSub = LoginUrlService.get().subscribe((loginUrl) => {
      this.setState({ loginHref: loginUrl });
    });
  }

  componentWillUnmount() {
    if (typeof document !== undefined) {
      document.removeEventListener(
        "closeAccountAndPaymentDropdown",
        this.closeAccountAndPaymentDropdown,
      );
    }

    if (this.navTokenSub) {
      this.navTokenSub.unsubscribe();
    }

    if (this.configPropSub) {
      this.configPropSub.unsubscribe();
    }

    if (this.onlineInvoicingSignUpUrl) {
      this.onlineInvoicingSignUpUrl.unsubscribe();
    }

    if (this.loginUrlSub) {
      this.loginUrlSub.unsubscribe();
    }
  }

  closeAccountAndPaymentDropdown() {
    this.setState({
      myAccountAndPaymentsMenuHasMouse: false,
      myAccountAndPaymentsHasMouse: false,
    });
  }

  setMyAccountAndPaymentsHasMouse(value: boolean) {
    this.setState({
      myAccountAndPaymentsHasMouse: value,
    });
  }

  setMyAccountAndPaymentsMenuHasMouse(value: boolean) {
    this.setState({
      myAccountAndPaymentsMenuHasMouse: value,
    });
  }

  render() {
    const disabledClass = UserService.displayUserInfo() ? "" : " disabled";
    const ordersProps: Record<string, string> = {};
    const dashboardProps: Record<string, string> = {};

    if (UserService.displayUserInfo()) {
      ordersProps.href = this.state.ordersHref;
      dashboardProps.href = this.state.dashboardHref;
    }

    return (
      <>
        <div className="user-panel" style={this.props.style}>
          <span className="position-absolute">
            <span className="position-relative">
              <UserGreeting
                isLoggedIn={this.props.isLoggedIn}
                isCookied={this.props.isCookied}
                firstName={this.props.firstName}
                loginHref={this.state.loginHref}
                registerHref={this.state.registerHref}
                displayRegisterLink={
                  this.props.displayState.displayRegisterLink
                }
                className="d-block"
              />
            </span>
          </span>
          <div
            className="d-inline-block panel-item my-account"
            onMouseEnter={() => {
              this.setMyAccountAndPaymentsHasMouse(true);
            }}
            onMouseLeave={() => {
              this.setMyAccountAndPaymentsHasMouse(false);
            }}
          >
            <span className="account-icon">
              <span className="icon-image" />
              <span className="pre-load" />
            </span>
            <span className="d-block account-text">My Account & Payments</span>
          </div>
          <MyListsHeaderClient
            myListsUrl={this.props.myListsUrl}
            displayUserInfo={UserService.displayUserInfo()}
            onClick={() => {
              this.props.setMyListsOpen(true);
            }}
          />
          {this.props.displayState.displayOrders ? (
            <a
              className={`d-inline-block panel-item panel-item-margin orders ${disabledClass} ${
                ordersProps.href ? "active" : ""
              }`}
              {...ordersProps}
            >
              <span className="orders-icon">
                <span className="icon-image" />
                <span className="pre-load" />
              </span>
              <span className="panel-label">Orders</span>
            </a>
          ) : (
            <span
              className={
                "d-inline-block panel-item panel-item-margin invisible"
              }
            >
              <span className="orders-icon">
                <span className="icon-image" />
                <span className="pre-load" />
              </span>
              <span className="panel-label">Orders</span>
            </span>
          )}

          {this.props.displayState.displayDashboard ? (
            <a
              className={`d-inline-block panel-item panel-item-margin ${
                dashboardProps.href ? "active" : ""
              }`}
              {...dashboardProps}
            >
              <Icon>dashboard</Icon>
              <span className="panel-label">Dashboard</span>
            </a>
          ) : (
            <span
              className={
                "d-inline-block panel-item panel-item-margin invisible"
              }
            >
              <Icon>dashboard</Icon>
              <span className="panel-label">Dashboard</span>
            </span>
          )}

          <span
            className={
              "d-inline-block panel-item panel-item-margin" +
              disabledClass +
              (this.props.useNotificationAnimation &&
              UserService.displayUserInfo()
                ? " ringing-bell"
                : "")
            }
            tabIndex={0}
            onClick={() => {
              if (UserService.displayUserInfo()) {
                this.props.setNotificationsOpen(true);
              }
            }}
          >
            <Icon>notifications</Icon>
          </span>

          {UserService.displayUserInfo() && (
            <NotificationCount
              count={this.props.notificationCount}
              top={4}
              left={5}
            />
          )}

          <div className="d-inline-block cart-divider"></div>
        </div>
        {(this.state.myAccountAndPaymentsHasMouse ||
          this.state.myAccountAndPaymentsMenuHasMouse) && (
          <DesktopDropdown
            isLoggedIn={this.props.isLoggedIn}
            className="my-account-and-payment-menu"
            onMouseEnter={() => {
              this.setMyAccountAndPaymentsMenuHasMouse(true);
            }}
            onMouseLeave={() => {
              this.setMyAccountAndPaymentsMenuHasMouse(false);
            }}
            hasMultipleAccounts={this.props.hasMultipleAccounts}
            style={this.props.styleDropdown}
            onlineInvoicingSignUpUrl={this.state.onlineInvoicingSignUpUrl}
            oiSignup={this.state.oiSignup}
            accountStatement={this.state.accountStatement}
          />
        )}
      </>
    );
  }
}

export default UserPanel;
